import { HashRouter, Route, Routes } from "react-router-dom";
import ProtectedLayout from "../Component/Main/ProtectedLayout";
import Login from '../Views/Auth/Login';
import Dashboard from "../Views/Dashboard/Dashboard";
import NotFound from "../Views/NotFound/NotFound";
import Employee from "../Views/Employee/Employee";
import RoleUser from "../Views/RoleUser/RoleUser";
import Profile from "../Views/Profile/Profile";
import Settings from "../Views/Settings/Settings";
import Company from "../Views/Company/Company";
import Division from "../Views/Division/Division";
import Position from "../Views/Position/Position";
import Area from "../Views/Area/Area";
import Level from "../Views/Level/Level";
import SubmissionRegular from "../Views/SubmissionRegular/SubmissionRegular";
import Meeting from "../Views/Meeting/Meeting";
import MeetingLocation from "../Views/MeetingLocation/MeetingLocation";
import Benefit from "../Views/Benefit/Benefit";
import LevelDetail from "../Views/LevelDetail/LevelDetail";
import BenefitForm from "../Views/Benefit/BenefitForm";
import Approval from "../Views/Approval/Approval";
import SubmissionTravel from "../Views/SubmissionTravel/SubmissionTravel";
import SubmissionTravelDetail from "../Views/SubmissionTravel/SubmissionTravelDetail";
import SubmissionRegularDetail from "../Views/SubmissionRegular/SubmissionRegularDetail";
import Organize from "../Views/Organize/Organize";
import Settlement from "../Views/Settlement/Settlement";
import SettlementDetail from "../Views/Settlement/SettlementDetail";
import ApprovalSettlement from "../Views/ApprovalSettlement/ApprovalSettlement";
import ChangePassword from "../Views/ChangePassword/ChangePassword";
import Shift from "../Views/Shift/Shift";
import Overtime from "../Views/Overtime/Overtime";
import LeavePaid from "../Views/LeavePaid/LeavePaid";
import LeaveType from "../Views/LeaveType/LeaveType";
import Attendance from "../Views/Attendance/Attendance";
import ApprovalOvertime from "../Views/ApprovalOvertime/ApprovalOvertime";
import ApprovalLeavePaid from "../Views/ApprovalLeavePaid/ApprovalLeavePaid";
import ApprovalAttendance from "../Views/ApprovalAttendance/ApprovalAttendance";
import ApprovalUserLeavePaid from "../Views/ApprovalUserLeavePaid/ApprovalUserLeavePaid";
import HRApproval from "../Views/HRApproval/HRApproval";
import UserShift from "../Views/UserShift/UserShift";
import Schedule from "../Views/Schedule/Schedule";
import Kpi from "../Views/KPI/Kpi";
import UserSchedule from "../Views/UserSchedule/UserSchedule";
import ApprovalReimbursement from "../Views/ApprovalReimbursement/ApprovalReimbursement";
import MyKpi from "../Views/KPI/MyKpi";
import PrivacyPolicy from "../Views/Privacy/PrivacyPolicy";
import KpiTask from "../Views/KPI/KPITask";
import Payroll from "../Views/Payroll/Payroll";
import PayrollGroupDetail from "../Views/Payroll/PayrollGroupDetail";
import PayTitle from "../Views/Payroll/PayTitle";
import Salary from "../Views/Payroll/Salary";
import AttendanceLocation from "../Views/AttendanceLocation/AttendanceLocation";
import Notification from "../Views/Notification/Notification";
import NotificationDetail from "../Views/NotificationDetail/NotificationDetail";
import ProfileRequest from "../Views/ProfileRequest/ProfileRequest";
import VehicleList from "../Views/Vehicle/Vehicles";
import LoanRequestList from "../Views/Loan/LoanRequestList";

import LoanUserBanList from "../Views/LoanUserBan/LoanUserBan";

import LoanApprovalList from "../Views/LoanApproval/LoanApproval";
import ApprovalChangeShift from "../Views/ApprovalChangeShift/ApprovalChangeShift";
import UserAttendanceLocation from "../Views/UserAttendanceLocation/UserAttendanceLocation";
import DelegationAttendance from "../Views/DelegationAttendance/DelegationAttendance";
import DelegationReimbursement from "../Views/DelegationReimbursement/DelegationReimbursement";
import DelegationOvertime from "../Views/DelegationOvertime/DelegationOvertime";
import DelegationLeavePaid from "../Views/DelegationLeave/DelegationLeave";
import DelegationChangeShift from "../Views/DelegationChangeShift/DelegationChangeShift";
import Holiday from "../Views/Holiday/Holiday";
import EmployeeStatus from "../Views/EmployeeStatus/EmployeeStatus";
import VendorAsset from "../Views/VendorAsset/VendorAsset";
import AssetCategory from "../Views/Asset/AssetCategory";
import Asset from "../Views/Asset/Asset";
import AssetMaintenance from "../Views/Asset/AssetMaintenance";
import AssetRequest from "../Views/Asset/AssetRequest";
import AssetApprovalRequest from "../Views/Asset/AssetApprovalRequest";
import AssetReceiptPreview from "../Views/Asset/AssetReceiptPreview";
import AssetDelegationRequest from "../Views/Asset/AssetDelegationRequest";
import WarningLetterAdmin from "../Views/WarningLetter/WarningLetterAdmin";
import WarningLetterEmployee from "../Views/WarningLetter/WarningLetterEmployee";

function Router({ history }) {
  return (
      <HashRouter history={history}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/privacypolicy" element={<PrivacyPolicy />} />
          <Route path="/" element={<ProtectedLayout />} >
            <Route path="/" element={<Dashboard />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/perjalanandinas" element={<SubmissionTravel />} />
            <Route path="/detailperjalanandinas" element={<SubmissionTravelDetail />} />
            <Route path="/detailregular" element={<SubmissionRegularDetail />} />
            <Route path="/regular" element={<SubmissionRegular />} />
            <Route path="/employee" element={<Employee />} />
            <Route path="/access" element={<RoleUser />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/company" element={<Company />} />
            <Route path="/division" element={<Division />} />
            <Route path="/level" element={<Level />} />
            <Route path="/area" element={<Area />} />
            <Route path="/position" element={<Position />} />
            <Route path="/meeting" element={<Meeting />} />
            <Route path="/benefit" element={<Benefit />} />
            <Route path="/benefitform" element={<BenefitForm />} />
            <Route path="/leveldetail" element={<LevelDetail />} />
            <Route path="/approval" element={<Approval />} />
            <Route path="/approvalsettlement" element={<ApprovalSettlement />} />
            <Route path="/organize" element={<Organize />} />
            <Route path="/settlement" element={<Settlement />} />
            <Route path="/detailsettlement" element={<SettlementDetail />} />
            <Route path="/changepassword" element={<ChangePassword />} />
            <Route path="/shift" element={<Shift />} />
            <Route path="/overtime" element={<Overtime />} />
            <Route path="/leavepaid" element={<LeavePaid />} />
            <Route path="/leavetype" element={<LeaveType />} />
            <Route path="/attendance" element={<Attendance />} />
            <Route path="/approvalovertime" element={<ApprovalOvertime />} />
            <Route path="/approvalleavepaid" element={<ApprovalLeavePaid />} />
            <Route path="/approvaluserleavepaid" element={<ApprovalUserLeavePaid />} />
            <Route path="/approvalattendance" element={<ApprovalAttendance />} />
            <Route path="/hrapproval" element={<HRApproval />} />
            <Route path="/approvalreimbursement" element={<ApprovalReimbursement />} />
            <Route path="/usershift" element={<UserShift />} />
            <Route path="/schedule" element={<Schedule />} />
            <Route path="/mykpi" element={<MyKpi />} />
            <Route path="/kpi" element={<Kpi />} />
            <Route path="/userschedule" element={<UserSchedule />} />
            <Route path="/kpitask" element={<KpiTask />} />
            <Route path="/payrollemployee" element={<Payroll />} />
            <Route path="/payrollemployee/group/:id" element={<PayrollGroupDetail />} />
            <Route path="/paytitle" element={<PayTitle />} />
            <Route path="/payslip" element={<Salary />} />
            <Route path="/attendancelocation" element={<AttendanceLocation />} />
            <Route path="/notification" element={<Notification />} />
            <Route path="/notification/detail/:id" element={<NotificationDetail />} />
            <Route path="/approvalprofile" element={<ProfileRequest />} />
            <Route path="/vehicle" element={<VehicleList />} />
            <Route path="/loanrequest" element={<LoanRequestList />} />
            <Route path="/loanapproval" element={<LoanApprovalList />} />
            <Route path="/shiftapprovalchanges" element={<ApprovalChangeShift />} />
            <Route path="/userattendance" element={<UserAttendanceLocation />} />
            <Route path="/attendancedelegation" element={<DelegationAttendance />} />
            <Route path="/reimbursementdelegation" element={<DelegationReimbursement />} />
            <Route path="/overtimedelegation" element={<DelegationOvertime />} />
            <Route path="/leavedelegation" element={<DelegationLeavePaid />} />
            <Route path="/changeshiftdelegation" element={<DelegationChangeShift />} />
            <Route path="/holiday" element={<Holiday />} />
            <Route path="/meetinglocation" element={<MeetingLocation />} />
            <Route path="/employeestatus" element={<EmployeeStatus />} />
            <Route path="/vendor" element={<VendorAsset />} />
            <Route path="/assetcategory" element={<AssetCategory />} />
            <Route path="/asset" element={<Asset />} />
            <Route path="/maintenance" element={<AssetMaintenance />} />
            <Route path="/assetrequest" element={<AssetRequest />} />
            <Route path="/assetapproval/receipt" element={<AssetReceiptPreview />} />
            <Route path="/assetapproval" element={<AssetApprovalRequest />} />
            <Route path="/assetdelegation" element={<AssetDelegationRequest />} />
            <Route path="/loanuserban" element={<LoanUserBanList />} />
            <Route path="/warningletters/admin" element={<WarningLetterAdmin />} />
            <Route path="/warningletters/me" element={<WarningLetterEmployee />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
        </HashRouter>
  );
}


export default Router;